import { render, staticRenderFns } from "./InvestmentPropertyIcon.vue?vue&type=template&id=64016168&scoped=true&functional=true"
import script from "./InvestmentPropertyIcon.vue?vue&type=script&lang=js"
export * from "./InvestmentPropertyIcon.vue?vue&type=script&lang=js"
import style0 from "./InvestmentPropertyIcon.vue?vue&type=style&index=0&id=64016168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "64016168",
  null
  
)

export default component.exports